import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import UnloadsFilters from "./unloads/UnloadsFilters";
import UnloadsTable from "./unloads/UnloadsTable";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";

const ViewUnloads = () => {
    const {t: _Tr} = useTranslation("routes");

    const bread = [
        {name: _Tr("labels.reports"), url: "/reports/", current: false},
        {name: _Tr("labels.unloads"), current: true},
    ];

    const title = _Tr("labels.unloads");

    const [itemsShown, setItemsShown] = useState([]);
    const itemsRef = useRef([]);
    const [days, setDays] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const filters = useRef({});
    const pagerModelRef = useRef(new PagerModel());

    const [params, setParams] = useState({
        groups: [],
        islands: [],
        routes: [],
        zones: [],
    });

    useEffect(() => {
        document.title = title;
        axiApi.get("/api/unloads/containers/filters/").then((resp) => {
            let params_ = {...params};
            params_.groups = [...resp.data.groups];
            params_.islands = [...resp.data.islands];
            params_.routes = [...resp.data.routes];
            params_.zones = [...resp.data.zones];
            setParams(params_);
        });
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => applyFilters();
    }, []);

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/unloads/containers/filter/", filters.current, {
                params: pagerModelRef.current.paging.getParams(),
            })
            .then((resp) => {
                if ("items" in resp.data && resp.data.items.length) {
                    itemsRef.current = [...resp.data.items];
                    setItemsShown([...resp.data.items]);
                    setDays(resp.data.days);
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((err) => {
                console.error("Error", err);
            })
            .finally((err) => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-12">
                    <h3 className="mt-2">{title}</h3>
                    <UnloadsFilters
                        filters={filters}
                        params={params}
                        applyFilters={applyFilters}
                        setItemsShown={setItemsShown}
                        isLoading={isLoading}
                    />
                </div>
                <TopBarPagination stickyTopValue="68px" pagerModel={pagerModelRef.current} />

                <div className="col-12">
                    <UnloadsTable
                        itemsShown={itemsShown}
                        setItemsShown={setItemsShown}
                        isLoading={isLoading}
                        days={days}
                        paging={pagerModelRef.current.paging}
                        filters={filters}
                    />
                </div>
            </div>
        </>
    );
};
export default ViewUnloads;
